import { mapGetters, mapActions } from 'vuex';
import CookieJar from '@/utilities/cookieJar';

export const formSteps = {
    data () {
		return {
            showStepErrors: false,
            activityList: []
        };
    },
    computed: {
        noItemsAdded () {
            return this.getItemsByType ? this.getItemsByType.length < 1 : false;
        },
        otherCriteriaValid () {
            // additional conditions for validity may be set per section
            return true;
        },
        ...mapGetters('claim', ['getCurrentClaim']),
        ...mapGetters('childEntities', ['getItems'])
        },
    mounted () {
        const formEle = document.querySelector('form');
        const focusableEles = formEle.querySelectorAll('.form-control, a, button');

        focusableEles[0].focus();

        // We get a list of claims back so we need to grab the information for the current one
        // based on it's ID
        this.fetchCurrentClaim(this.$route.params.claimId).then((res) => {
            Object.assign(this.formData, this.getCurrentClaim);
        });

        this.fetchEligibleActivities();
	},
    methods: {
        saveAndSubmit (nextStep, validateStep = true, finalSubmit = false) {
            const formEle = document.querySelector('form');
            const focusableEles = formEle.querySelectorAll('.form-control, a, button');

            this.showStepErrors = true;
            if (!validateStep || (this.isValid(this.$refs.form) && !this.noItemsAdded && this.otherCriteriaValid)) {
                /* If we're continuing (validateStep is true) we want to save the next step as the one to return to,
                otherwise, we should return the user to the one they saved last */
                const returnStep = validateStep ? nextStep : this.$route.name;

                // set ua_claimsubmitted to 1/true if this is the final submission
                this.formData.ua_claimsubmitted = finalSubmit ? 1 : 2;

                this.submitClaim(finalSubmit, returnStep, nextStep);
            } else {
                window.scrollTo(0, 0);
                focusableEles[0].focus();
            }
        },
        submitClaim (finalSubmit, returnStep, nextStep) {
            this.updateClaim(this.formData).then((res) => {
                if (res === true) {
                    // If the claim was successfully updated, go off and update the activities as well
                    this.flagActivitiesClaimed(nextStep);
                } else if (res.status === 401) {
                    this.redeemToken({
                        refreshtoken: CookieJar.get(`${process.env.VUE_APP_COOKIE_PREFIX}refresh_token`),
                        businessunit: process.env.VUE_APP_BUSINESS_UNIT
                    }).then((res) => {
                        if (res === true) {
                            this.submitClaim(finalSubmit, returnStep, nextStep);
                            return true;
                        }
                        this.$router.push({ name: 'Login' });
                    }).catch(() => {
                        this.$router.push({ name: 'Login' });
                    });
                }
            }).catch((err) => {
                this.error = err.message;
            });
        },
        flagActivitiesClaimed (nextStep) {
            const promises = this.activityList.map((activity) => {
                // Loop through all the activities selected and grab their data object because we need to send the whole thing up
                const activityData = this.getItems('activities').find(elActivity => elActivity.ua_icactivitylineid === activity.value);

                // If the activity has been selected, the claim ID should be null, if not, it should be set to the current claim ID
                const claimId = !activity.selected ? null : this.$route.params.claimId;

                const payload = {
                    data: {
						...activityData,
						...{ ua_claim: claimId }
					},
                    id: activity.value,
					itemType: 'activities'
                };

                return this.editById(payload).catch((err) => {
                  throw err;
                });
              });

              Promise.all(promises).then(() => {
                // When all of the activities have been updated, send the user back to the dashboard (or the confirmation page if they've submitted)
                this.$router.push({ name: nextStep });
              });
        },
        parseBoolAsInt (fieldName) {
            // We send the declarations up as 1 or 0 (yes or no) but we get tham back down as true/false.
            // This is to facilitate prefilling the checkboxes from server data
			if (typeof fieldName === 'boolean') {
				return fieldName ? 1 : 0;
			}
			return fieldName;
		},
		getSelected (data) {
            // add selected activity values to selectedActivities array. This is used to prefill checkboxes
			this.selectedActivities = data;

            // set chosenActivities to empty array
			this.chosenActivities = [];

            this.activityList.forEach((activity) => {
                // To start with set every activity in the list to unselected
                activity.selected = false;
            });

            data.forEach((activity) => {
                // After that, go through the selected ones, find them in the activityList, and set theire selected property to true

				const a = this.activityList.find(item => item.value === activity);

                a.selected = true;

                // Add the selected item's label to chosenActivities. This is to populate the reference list of selected activities
                this.chosenActivities.push(
					a.label
				);
			});
		},
		fetchEligibleActivities () {
            // If we don't already have a list of activities eligible for this claim, fetch activities from server
            if (!this.getEligibleActivities(this.$route.params.claimId).length) {
                this.fetchItems('activities').catch((err) => {
                    if (err.status === 422 || err.status === 500) {
                        this.activitesError.type = err.type;
                        this.activitesError.text = err.message;
                    }
                }).finally(() => {
                    // Add eligibile activities to a data prop - this is so we can manipulate it later
                    this.activityList = this.getEligibleActivities(this.$route.params.claimId);
                    this.activitiesLoading = false;
                    this.checkForSelected();
                });
            } else {
                this.activityList = this.getEligibleActivities(this.$route.params.claimId);
                this.activitiesLoading = false;
                this.checkForSelected();
            }
		},
        checkForSelected () {
            // check through the activity list for any activities that have previously been selected and
            // add them to the list of pre-selected options to show in the hceckbox list
            this.activityList.forEach((activity) => {
                if (activity.selected) {
                    this.selectedActivities.push(activity.value);
                    this.chosenActivities.push(activity.label);
                }
            });
        },
        ...mapActions('auth', ['redeemToken']),
        ...mapActions('claim', ['updateClaim', 'fetchCurrentClaim']),
        ...mapActions('childEntities', ['fetchItems', 'editById'])
    }
  };
